import { checkNested } from 'MODULES/checkNested';

import { CLASSIFIEDS_VIEW } from 'MODULES/CLASSIFIEDS_VIEW';

export const isCategoryPicturePriority = (category) => {
    const categoryViewType = checkNested(category, 'viewType', 0);

    return categoryViewType === CLASSIFIEDS_VIEW.clothes;
};
